export default "__VITE_ASSET__8efa170f__"